import React, { useContext } from "react";
import Edit from "../components/Admin/Edit";

import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserContext from "../contexts/UserContext";
import EditDriver from "../components/Admin/EditDriver";
import config from "../config";

const EditBooking = () => {
  const primaryColor = config.env.primaryColor || "#00df9a";
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const { id } = useParams();

  return (
    <div className="w-full py-16 px-4">
      <div className="max-w-[1240px] mx-auto">
        <div className="bg-gray-800 pb-32">
          <header className="py-10">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold tracking-tight" style={{ color: primaryColor }}>
                <Link to={`/dashboard`} className="hover:text-indigo-400">
                  {t("Navbar.dashboard")}{" "}
                </Link>
                / {t("EditPage.link")}
              </h1>
            </div>
          </header>
        </div>

        <div className="bg-gray-800 -mt-32">
          <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
            <div className="rounded-lg bg-black px-5 py-6 shadow sm:px-6">
              {user.role === 1 && <Edit id={id} />}
              {user.role === 2 && <EditDriver id={id} driver={user} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBooking;
